export default "/assets/f0fac520e44143fb.svg"